module.exports = __webpack_public_path__ + "static/media/lula-em-aneis.0ae34639.jpg";